export default function reviewsSlider() {

    const reviewsSlider = document.querySelector('.js-reviewsSlider');

    if (!reviewsSlider) {
        return false;
    }

    $('.js-reviewsSlider').not('.slick-initialized').slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        // variableWidth: true,
        dotsClass: 'reviews_dots',
        prevArrow: '<button type="button" class="reviews_arrow-prev"></button>',
        nextArrow: '<button type="button" class="reviews_arrow-next"></button>',
        responsive: [
            {
                breakpoint: 1270,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 540,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                    dots: true,
                }
            }
        ]
    });


    const reviewsText = document.querySelectorAll('.js-reviewsText');
    const textLength = 187;

    reviewsText.forEach( function(item) {

        if (item.textContent.length <= textLength) {
            return false;
        }

        let currentText = item.textContent,
            textArr = currentText.split('');

        textArr.forEach( function(elem, index) {
            if (index >= textLength) {
                textArr.splice(textLength, index);
            }
        });

        let finalText = textArr.join('') + '...';

        item.textContent = finalText;
    });

}